import TipoNotificacao from '@/enums/tipo-notificacao';

function buildNotificacao(notificacao, user) {
  return {
    tipoNotificacao: notificacao,
    user: {
      id: user.id,
      nome: user.nome,
    },
    whatsapp: false,
    email: false,
  };
}

function userHasNotificationRole(key, user) {
  return user.roles.map(r => r.name)
    .filter(roleName => TipoNotificacao.keys[key].userRoles.includes(roleName));
}

export function buildNotificacoes(notificacoesResponse, user) {
  const notificacoesKeys = Object.keys(TipoNotificacao.keys);

  const notificacoes = { ...notificacoesResponse };

  notificacoesKeys
    .filter(key => !notificacoesResponse.content.map(not => not.tipoNotificacao).includes(key))
    .filter(key => userHasNotificationRole(key, user))
    .forEach(key => notificacoes.content.push(buildNotificacao(key, user)));

  notificacoes.content = notificacoes.content
    .sort((a, b) => a.tipoNotificacao.localeCompare(b.tipoNotificacao));
  notificacoes.total = notificacoes.content.length;

  return notificacoes;
}

export default { buildNotificacoes };
